<template>
  <el-dialog
    :visible="detailDialogVisible"
    title="审核详情"
    @open="openDialog"
    @close="closeDialog"
  >
    <el-form label-width="200px" :model="auditDetail">
      <el-form-item label="用户UID：">
        {{auditDetail.userId}}
      </el-form-item>
<!--      <el-form-item label="账户手机：">-->
<!--        {{auditDetail.tel}}-->
<!--      </el-form-item>-->
<!--      <el-form-item label="账户邮箱：">-->
<!--        {{auditDetail.email}}-->
<!--      </el-form-item>-->
      <el-form-item label="国籍：">
        {{auditDetail.countryZh}} {{auditDetail.countryEn}}
      </el-form-item>
      <el-form-item label="用户姓名：">
        {{auditDetail.realName}}
      </el-form-item>
      <el-form-item label="证件号码：">
        {{auditDetail.cardNo}}
      </el-form-item>
      <!-- <el-form-item label="国家/地区：">
        {{auditDetail.countryZh}}&nbsp;&nbsp;{{auditDetail.countryEn}}
      </el-form-item> -->
      <el-form-item label="证件照片：">
        <image-wrapper 
          v-for="(url, index) in auditDetail.__attachUrl"
          :key="index"
          :src="url" 
          :inline="true"
          width="300px"
          height="150px"
        ></image-wrapper>
      </el-form-item>
      <el-form-item label="KYC关联账号：">
        <el-table :data="auditDetail.userObj">
          <el-table-column prop="uid" label="UID"></el-table-column>
          <el-table-column prop="email" label="账号"></el-table-column>
          <el-table-column  prop="gname" label="用户分组">
<!--            <template slot-scope="scope">-->
<!--              {{scope.row.groupId}}-->
<!--              {{ scope.row.groupId === 1 || scope.row.groupId === null ? "普通用户" : getthisGroup(1) }}-->
<!--            </template>-->
          </el-table-column>
          <el-table-column prop="time" label="KYC认证时间">
            <template slot-scope="scope">
              {{scope.row.time | moment}}
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
    </el-form>
    <el-input 
        v-if="auditDetail.status === 2 && auditDetail.backReason !== ''"
        type="textarea" 
        disabled
        :value="auditDetail.backReason" 
        class="reason-input"></el-input>
    <span slot="footer" class="dialog-footer">
      <el-button 
        @click="toggleDetailDialogVisible(false)"
        v-if="auditDetail.status === 0 || auditDetail.status === 2"
      >取消</el-button>
      <el-button 
        type="primary" 
        @click="approveAudit(true)"
        v-if="auditDetail.status === 0 || auditDetail.status === 2"
      >审核通过</el-button>
      <el-button 
        type="danger" 
        @click="approveAudit(false)"
        v-if="auditDetail.status === 0 || auditDetail.status === 2"
      >审核不通过</el-button>
      <el-button 
        type="danger" 
        @click="joinBlackList"
        v-if="auditDetail.status === 0 || auditDetail.status === 2"
      >加入黑名单</el-button>
      <el-button 
        @click="toggleDetailDialogVisible(false)"
        v-if="auditDetail.status !== 0 || auditDetail.status !== 2"
      >关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import ImageWrapper from 'components/image';

export default {
  name: 'AuditDetail',
  props: ['value'],
  components: {
    ImageWrapper
  },
  methods: {
    ...mapActions('kycAudit', ['detail', 'approve','getGroupOne']),
    ...mapMutations('kycAudit', ['toggleDetailDialogVisible']),
    openDialog() {
      this.detail(this.value);
    },
    getthisGroup(getid){
      var glist=  this.getGroupOne();

      let res={};
      this.glist.forEach(item=> {
        console.log("item id :"+item.id)
        if (item.id===getid){
          res=item;
        }
      })
      return res;
    },
    closeDialog() {
      this.toggleDetailDialogVisible(false);
    },
    approveAudit(isPass) {
      const action = isPass
        ? this.$confirm('确认执行此操作吗？', '提示', {
            type: 'warning'
          })
        : this.$prompt('请输入审核不通过原因', '提示', {
            inputValidator: value => {
              return !value || !value.trim() ? '请输入不通过原因' : true;
            }
          });

      action
        .then(({ value }) => {
          this.approve({
            id: this.value,
            backReason: isPass ? undefined : value,
            status: isPass ? 1 : 3
          }).then(() => {
            this.$message({
              type: 'success',
              message: '操作成功！'
            });
            this.toggleDetailDialogVisible(false);
            this.$emit('onUpdate');
          });
        })
        .catch(() => {});
    },
    joinBlackList() {
      this.approve({
            id: this.value,
            backReason: undefined,
            status: -1
          }).then(() => {
            this.$message({
              type: 'success',
              message: '操作成功！'
            });
            this.toggleDetailDialogVisible(false);
            this.$emit('onUpdate');
          });
    }
  },
  computed: {
    ...mapState('kycAudit', ['detailDialogVisible']),
    ...mapGetters('kycAudit', ['auditDetail'])
  }
};
</script>

<style lang="less" scoped>
@import '~styles/variables.less';

.reason-input {
  width: 100%;
  /deep/ .el-textarea__inner {
    border-color: @color-danger;
    background-color: lighten(@color-danger, 25%);
    resize: none;
    color: #333;
  }
}
</style>
